// app/javascript/components/ForgotPassword.jsx
import React, { useState } from 'react';

const ForgotPassword = ({ onBack }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    security_answer: '',
    new_password: '',
    confirm_password: ''
  });
  const [question, setQuestion] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleStep1Submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`/api/v1/password_reset/question?email=${formData.email}`);
      const data = await response.json();

      if (response.ok) {
        setQuestion(data.security_question);
        setStep(2);
      } else {
        setResult({ success: false, message: data.message });
      }
    } catch (err) {
      setResult({ success: false, message: 'Network error' });
    } finally {
      setLoading(false);
    }
  };

  const handleStep2Submit = async (e) => {
    e.preventDefault();
    setStep(3);
  };

  const handleStep3Submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('/api/v1/password_reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          security_answer: formData.security_answer,
          new_password: formData.new_password,
          confirm_password: formData.confirm_password
        })
      });

      const data = await response.json();
      setResult({ success: response.ok, ...data });
    } catch (err) {
      setResult({ success: false, message: 'Network error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="posRel loginPg">
      <div className="loginBg">
        <img src="/images/loginBG.jpg" alt="" />
      </div>
      <div className="loginBoxMain">
        <div className="loginBox">
          <a href="#" className="mAuto mb_24 loginLogo">
            <img src="/images/logo.png" alt="" />
          </a>
          <div className="textCenter maxW_300 mAuto mb_24 loginHD">
            <h1 className="colorTextDark mb_16">Reset Password</h1>
            <p>
              {step === 1 && 'Enter your email or Army ID'}
              {step === 2 && 'Answer the security question'}
              {step === 3 && 'Set your new password'}
            </p>
          </div>

          {result ? (
            <div className="lsForm">
              {result.success ? (
                <div style={{ color: 'green', marginBottom: '16px', textAlign: 'center' }}>
                  <p>{result.message}</p>
                  <p>You can now login with your new password.</p>
                </div>
              ) : (
                <div style={{ color: 'red', marginBottom: '16px', textAlign: 'center' }}>
                  {result.message}
                </div>
              )}
              <button className="btnBig fullWidth" onClick={onBack}>
                Back to Login
              </button>
            </div>
          ) : step === 1 ? (
            <div className="lsForm">
              <form onSubmit={handleStep1Submit}>
                <div className="formInpt mb_20">
                  <label className="mb_8">Email or Army ID</label>
                  <input
                    type="text"
                    name="email"
                    placeholder="Enter email or Army ID"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <input
                  type="submit"
                  value={loading ? "Loading..." : "Continue"}
                  className="btnBig fullWidth"
                  disabled={loading}
                />
              </form>
              <div className="textCenter mt_20">
                <button
                  className="colorYellow fwBold"
                  onClick={onBack}
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  Back to Login
                </button>
              </div>
            </div>
          ) : step === 2 ? (
            <div className="lsForm">
              <div style={{ marginBottom: '16px', fontSize: '14px', color: '#666', textAlign: 'center' }}>
                <strong>{question}</strong>
              </div>
              <form onSubmit={handleStep2Submit}>
                <div className="formInpt mb_20">
                  <label className="mb_8">Answer</label>
                  <input
                    type="text"
                    name="security_answer"
                    placeholder="Enter your answer"
                    value={formData.security_answer}
                    onChange={handleChange}
                    required
                  />
                </div>
                <input
                  type="submit"
                  value="Continue"
                  className="btnBig fullWidth"
                />
              </form>
              <div className="textCenter mt_20">
                <button
                  className="colorYellow fwBold"
                  onClick={() => setStep(1)}
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  Back
                </button>
              </div>
            </div>
          ) : (
            <div className="lsForm">
              <form onSubmit={handleStep3Submit}>
                <div className="formInpt mb_20">
                  <label className="mb_8">New Password</label>
                  <input
                    type="password"
                    name="new_password"
                    placeholder="Enter new password"
                    value={formData.new_password}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="formInpt mb_20">
                  <label className="mb_8">Confirm Password</label>
                  <input
                    type="password"
                    name="confirm_password"
                    placeholder="Confirm new password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    required
                  />
                </div>
                <input
                  type="submit"
                  value={loading ? "Resetting..." : "Reset Password"}
                  className="btnBig fullWidth"
                  disabled={loading}
                />
              </form>
              <div className="textCenter mt_20">
                <button
                  className="colorYellow fwBold"
                  onClick={() => setStep(2)}
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  Back
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
